import * as React from 'react';
import { Button, ButtonTheme } from '@cian/button-component';

import * as styles from './Footer.css';

interface IFooterProps {
  showAllUrl: string;
  onClickShowAllButton(): void;
  onClickHideButton(): void;
}

export const Footer: React.FC<IFooterProps> = ({ showAllUrl, onClickShowAllButton, onClickHideButton }) => {
  return (
    <div className={styles.root}>
      <span className={styles.description}>Копии объявления от других продавцов</span>

      <div>
        <Button theme={ButtonTheme.Default} className={styles.button} onClick={onClickShowAllButton}>
          <a href={showAllUrl} target="_blank" className={styles['show-all-link']}>
            Посмотреть все объявления
          </a>
        </Button>

        <Button theme={ButtonTheme.Ghost} className={styles.button} onClick={onClickHideButton}>
          Скрыть
        </Button>
      </div>
    </div>
  );
};
